export const updateCustomerCredReducer = {
  updateCustomerCred: (state, action) => {
    const {
      customerId,
      customerRefNum,
      Authorization,
      isSocialLoginNeeded,
      showReferralScreen,
    } = action.payload;
    state.customerId = customerId;
    state.customerRefNum = customerRefNum;
    state.Authorization = Authorization;
    state.isSocialLoginNeeded = isSocialLoginNeeded;
    state.showReferralScreen = showReferralScreen;
  },
};
